<template>
  <div class="policies_list">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="wrap-device-list_bg">
      <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
        <div class="filters">
          <div class="filter">
            <fg-input
                v-model="filter.q"
                type="text"
                class="search_user"
                :placeholder="translate('diadoc.policies.search')"
                :clearable="true"
                @input="change_input"
            />
          </div>

          <div class="filter">
            <tree-select
                :options="active_list"
                :multiple="false"
                v-model="filter.is_active"
                :placeholder="translate('diadoc.policies.is_active')"
                :clearable="true"
                @input="change_input"
            />
          </div>

          <div class="filter"></div>
          <div class="filter"></div>
          <div class="filter"></div>
          <div class="filter"></div>
        </div>
      </div>
    </div>

    <div class="response_table">
      <div v-if="loading">
        <div class="spinner">
          <scale-loader />
        </div>
      </div>

      <table v-else>
        <thead>
          <tr>
            <th scope="col"> {{ translate('diadoc.policies.name') }} / {{ translate('diadoc.policies.code') }} </th>
            <th class="w5per" scope="col"> {{ translate('diadoc.policies.is_active') }} </th>

            <th class="w7per" scope="col"> {{ translate('diadoc.policies.processed') }} </th>
            <th class="w7per" scope="col"> {{ translate('diadoc.policies.counteragent_inn') }} </th>
            <th scope="col"> {{ translate('diadoc.policies.extraction_prompt') }} </th>
            <th scope="col"> {{ translate('diadoc.policies.required_fields') }} </th>
            <th scope="col"> {{ translate('diadoc.policies.params') }} </th>
            <th class="w7per" scope="col"> {{ translate('diadoc.policies.updated_at') }} </th>
          </tr>
        </thead>
        <tbody>
          <tr
              class="policies_item"
              v-for="(policy,key) in policies"
              :key="key"
          >
            <td class="text-left" :data-label="translate('diadoc.policies.name') + ' / ' + translate('diadoc.policies.code')">
              <p>{{ policy.name }}</p>
              <p>{{ policy.code }}</p>
            </td>
            <td class="w5per" :data-label="translate('diadoc.policies.is_active')"> {{ policy.is_active }} </td>
            <td class="w7per" :data-label="translate('diadoc.policies.processed')">
              <router-link v-if="policy.last_diadoc_document_id" :to="'/diadoc_document/' + policy.last_diadoc_document_id">
                {{ policy.last_diadoc_document_id }}
              </router-link>
              ({{ policy.pending_documents_count }})
            </td>
            <td class="w7per" :data-label="translate('diadoc.policies.counteragent_inn')"> {{ policy.counteragent_inn }} </td>
            <td :data-label="translate('diadoc.policies.extraction_prompt')"> {{ policy.extraction_prompt }} </td>
            <td class="text-left" :data-label="translate('diadoc.policies.required_fields')">
              <p class="required_field" v-for="(field, field_key) in policy.required_fields" :key="field_key" v-html="field.label"/>
            </td>
            <td class="text-left" :data-label="translate('diadoc.policies.params')">
              <p>{{ `${translate('diadoc.policies.content_must_contain')}: ${policy.content_must_contain}\n` }}</p>
              <p>{{ `${translate('diadoc.policies.document_category')}: ${policy.document_category}\n` }}</p>
              <p>{{ `${translate('diadoc.policies.title_contains')}: ${policy.title_contains}\n` }}</p>
              <p>{{ `${translate('diadoc.policies.title_excludes')}: ${policy.title_excludes}\n` }}</p>
              <p>{{ `${translate('diadoc.policies.type_named_id')}: ${policy.type_named_id}\n` }}</p>
            </td>
            <td class="w7per" :data-label="translate('diadoc.policies.updated_at')"> {{ (policy.updated_at || '').split('.')[0] }} </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DiadocPolicies',
  components: {
  },
  data () {
    return {
      policies: [],
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
      filter:{
        is_active: null,
        q: ""
      },
      loading: false,
    }
  },

  created () {
    this.get_diadoc_policy_list()
  },

  watch:{

  },

  computed:{
    active_list(){
      return [
        {id: 0, label: "Только неактивные"},
        {id: 1, label: "Только активные"}
      ]
    },
    send_filter(){
      let filter = {}
      Object.keys(this.filter).forEach((item) => {
        this.filter[item] !== null && this.filter[item] !== "" && this.filter[item] !== undefined ? filter[item] = this.filter[item] : ""
      })
      return filter
    },
  },

  methods: {
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_diadoc_policy_list, 500)
    },
    get_diadoc_policy_list(){
      this.loading = true
      this.$http.v1.getDiadocDocumentParsePolicies(this.send_filter, (response) => {
        this.policies = response.data
        this.loading = false
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    }
  }
}
</script>

<style lang="scss" scoped>
  .policies_list {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;

    .header{
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 10px;
      .filters{
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        .filter{
          width: 100%;
          .form-group{
            margin: 0;
          }
        }
      }
    }

    .response_table{
      //padding: 10px 0 0;
      padding: 0;
      tbody{
        tr{
          font-size: 12px;
          &:hover{
            background-color: #eeeeee;
          }
        }
        .required_field{
          font-size: 12px;
          margin-bottom: 0;
          //text-wrap: nowrap;
        }

        .text-left{
          text-align: left;
        }

        .limit{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 1.5em;
          max-height: 3em;
          margin-bottom: 0;
          font-size: 12px;
        }

        p{
          font-size: 12px;
          margin-bottom: 5px;
        }
      }
    }
  }
</style>
